import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormGroup, FormBuilder, FormArray } from "@angular/forms";
import { DashboardService } from "../../../../../services/dashboard.service";
import { SharedService } from "../../../../../services/shared.service";

import * as _ from "lodash";

@Component({
  selector: "app-payload-form",
  templateUrl: "./payload-form.component.html",
  styleUrls: ["./payload-form.component.css"],
})
export class PayloadFormComponent implements OnInit {
  @Output() public jsonChanged = new EventEmitter<string>();

  json: any;
  jsonToArray: Array<any>;
  formArray: FormArray;
  request: any;

  suggestion: Array<boolean> = [];
  list: Array<string> = [];
  suggestionList: Array<string> = [];

  blocco: any;

  getGroupValue = (index) => this.formArray.controls[index].value;
  getGroup = (index) => this.formArray.controls[index];

  constructor(
    private fb: FormBuilder,
    private _dashboardService: DashboardService,
    private _sharedService: SharedService
  ) {}

  ngOnInit() {
    // this.blocco = this._sharedService.getBlocco();
    this.request = this._sharedService.getRequest();
    this.blocco = {
      ...this._sharedService.getBlocco(),
      ...(!this._sharedService.getBlocco().json && {
        json: this.request.json,
      }),
    };
    this.formArray = new FormArray([]);
    this.json = JSON.parse(this.blocco.json);
    this.jsonToArray = _.keys(this.json).map((key) => {
      return { nome: key, valore: this.json[key] };
    });
    for (const item of this.jsonToArray) {
      this.addNewFormGroup(item);
    }
    this.addNewFormGroup();
  }

  addNewFormGroup(item?: { nome: string; valore: string }) {
    this.formArray.push(
      this.fb.group({
        nome: [item && item.nome ? item.nome : ""],
        valore: [item && item.valore ? item.valore : ""],
      })
    );
    this.suggestion.push(false);
  }

  deleteRow(index: number) {
    // delete
    const values = this.formArray.value[index];
    const prevValues = this.jsonToArray[index];
    const { nome, valore } = values;
    const bloccoMetadataDelete = {
      idBlocco: this.blocco.id,
      nome: nome,
      valore: valore,
      id: prevValues.id,
    };
    this.formArray.removeAt(index);
    this.emitChange();
  }

  addRow(index: number) {
    const values = this.formArray.value[index];
    const prevValues = this.jsonToArray[index];
    const { nome, valore } = values;
    if (nome && valore) {
      const bloccoMetadata = {
        nome: nome,
        valore: valore,
      };
      if (prevValues) {
        //update
        this.emitChange();
      } else {
        //add
        this.jsonToArray.push(bloccoMetadata);
        this.addNewFormGroup();
        this.emitChange();
      }
    }
  }

  emitChange() {
    const jsonString = this.formArray.controls
      .filter((item) => item.value["nome"])
      .map(
        (element) =>
          `\"${element.value["nome"]}\":\"${element.value["valore"]}\"`
      )
      .join(",");
    this.jsonChanged.emit(jsonString);
  }

  checkSuggestions(event, i) {
    const input = event.target.value;
    const list = this.list.filter((item) =>
      item.startsWith(event.target.value)
    );
    const found = this.list.find((item) => item === input);
    if (input.startsWith("@") && list && list.length > 0 && !found) {
      this.suggestion[i] = true;
      this.suggestionList = list;
    } else {
      this.suggestion[i] = false;
    }
  }

  onSuggestionClick(suggestion, i) {
    let value = this.getGroup(i).get("valore");
    value.setValue(suggestion);
    this.suggestion[i] = false;
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/item-type-manager/forms/payload-form/payload-form.component.ts